import { Label, TextInput } from "@adasupport/byron";
import React from "react";

import { InputHint, Txt } from "components/Common";
import { NO_OP_FUNCTION } from "services/helpers";

import * as S from "./styles";

interface Props {
  inboundHostname: string;
  smtpPort: string;
  username: string;
  password: string;
  isInvalid?: boolean;
  isDisabled?: boolean;
}

export const ZendeskCredentialsSection = ({
  inboundHostname,
  smtpPort,
  username,
  password,
  isInvalid = false,
  isDisabled = false,
}: Props) => {
  return (
    <S.SectionGrid>
      <S.SectionNumber>1.</S.SectionNumber>
      <S.SectionContent>
        <Txt color="main" weight="semibold" size="small">
          Zendesk credentials
        </Txt>
        <Txt color="muted" size="small">
          Input your Zendesk credentials. You can find these in your Zendesk
          Admin Center, under the support addresses settings on the email
          channel page.
        </Txt>
        <S.FormGrid>
          <div>
            <Label>Inbound hostname</Label>
            <TextInput
              value={inboundHostname}
              placeholder="eg. smtp.email.zendesk.com"
              isInvalid={isInvalid}
              isDisabled={isDisabled}
              onChange={NO_OP_FUNCTION}
            />
          </div>
          <div>
            <Label>SMTP Port</Label>
            <TextInput
              value={smtpPort}
              placeholder="eg. 587"
              isInvalid={isInvalid}
              isDisabled={isDisabled}
              onChange={NO_OP_FUNCTION}
            />
          </div>
          <S.FullWidth>
            <Label>Username of this account</Label>
            <TextInput
              value={username}
              placeholder="eg. ada-lovelace"
              isInvalid={isInvalid}
              isDisabled={isDisabled}
              onChange={NO_OP_FUNCTION}
            />
          </S.FullWidth>
          <S.FullWidth>
            <Label>Password of this account</Label>
            <TextInput
              value={password}
              placeholder=""
              isInvalid={isInvalid}
              isDisabled={isDisabled}
              onChange={NO_OP_FUNCTION}
            />
            <InputHint>
              For data security, this field is hidden once saved.
            </InputHint>
          </S.FullWidth>
        </S.FormGrid>
      </S.SectionContent>
    </S.SectionGrid>
  );
};
